import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';

@Component({
  selector: 'app-guarantee-add',
  templateUrl: './guarantee-add.component.html',
  styleUrls: ['./guarantee-add.component.css']
})
export class GuaranteeAddComponent implements OnInit {
  serial: any = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe((params: Params) => {
      if (params.serial) this.serial = params.serial;
    })
  }

  ngOnInit() {
    console.log('vao dây ko', this.serial)
  }
  backToList(event) {
    this.router.navigate(['/evs/guarantee/logs'])
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/guarantee/guarantee-add.component.ts